// 江陵测控
import _ from "lodash"

export const JLCK = {
    CompanyId: 92,
}

export function isJLCK(store) {
    return _.get(store, 'getters.currentParentCompany') === JLCK.CompanyId
}
